import { createNavigation } from "next-intl/navigation";
import { defineRouting } from "next-intl/routing";

import { appConfig } from "@/configs";

const appConfigLanguageSetting = appConfig?.settings?.language || {};

export const DEFAULT = "en";
const languageCodes = appConfigLanguageSetting.languages.map((language: { code: string }) => language.code);
export const LOCALES: string[] = languageCodes.length > 0 ? languageCodes : [DEFAULT];
export const DEFAULT_LOCALE: string = appConfigLanguageSetting.defaultLanguage || DEFAULT;

export const routing = defineRouting({
  locales: LOCALES,
  defaultLocale: DEFAULT_LOCALE,
});

// @ts-expect-error Type system cannot infer the keyof type here since routing.pathnames is not yet defined as a type
export type Pathnames = keyof typeof routing.pathnames;
export type Locale = (typeof routing.locales)[number];

export const { Link, getPathname, redirect, usePathname, useRouter } = createNavigation(routing);
